import _ from 'lodash';
import i18n from 'i18next';
import { getCookie } from '../utiles/utiles'
import { initReactI18next } from 'react-i18next';

import locales from './locales'
import temp from './temp'

const getResources = () => {
  const resource = {
    en: format(locales.en, temp.en),
    ko: format(locales.ko, temp.ko),
    ja: format(locales.ja, temp.ja)
  }
  return resource
}

const format = (_locales, _temp) => _.merge(_locales, _temp)
const locale = getCookie('locale');

i18n
  .use(initReactI18next)
  .init({
    resources: getResources(),
    lng: locale,
    fallbackLng: 'ko',
    interpolation: {
      escapeValue: false
    }
  })

export default i18n;